// element-plus ui 组件单独引入
import { ElNotification, ElCheckbox, ElButton } from 'element-plus';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/checkbox/style/css';
import { h } from 'vue';
import { request } from '@vas2t-lowcode/api/src/core/api.base';
import { PRIVILEGE_URL } from '@/constant';
import { getPayConfig, getPositionRule } from '@/utils';
import { dwCollect } from '@/utils/dw-collect';

/**
 * @description: 应用权益即将到期推送
 * @return {*}
 */
export const appExpireNotice = (data: AppExpireNoticeData, goPay: (params: PayConfig | undefined) => void) => {
  // 计算过期天数
  const team_id = data.curr_team_info?.team_id || 0;
  const for_close_type = 'expired';
  const { is_expired, content, is_trial, expired_near_days: days } = data.notice || {};
  const teamRights = data.team_rights || {};
  const prefixStr = is_trial ? '试用' : '套餐';
  let title = days === 0 ? `${prefixStr}将在今天内到期` : `${prefixStr}即将在${days}天后到期`;
  if (is_expired) {
    title = `${prefixStr}已到期`;
  }

  // 判断权益为购买 | 续费
  let buttonText = '';
  let position = '';
  let purchase_type = 1;
  if (is_expired) {
    buttonText = '立即升级';
    position = `due2${is_trial ? '_try' : ''}`;
  } else {
    buttonText = `立即${is_trial ? '购买' : '续费'}`;
    position = `due1${is_trial ? '_try' : ''}`;
    purchase_type = is_trial ? purchase_type : 2;
  }

  // 展示埋点上报
  dwCollect({ func: getDwFunc(is_expired, is_trial), action: 'show' });

  // 调起通知
  const instance = ElNotification({
    title,
    duration: 0,
    message: h('div', [
      h('span', content),
      h('div', { class: 'el-notification__footer' }, [
        h(ElCheckbox, {
          class: 'el-notification__checkbox',
          label: '不再提示',
          onChange: () => {
            request('/lcdp/v1/team_notice/rights/close', {
              data: {
                team_id,
                for_close_type,
              },
              headers: {
                'Content-Type': 'application/json',
              },
              method: 'post',
            }).then(() => {
              instance.close();
            });
          },
        }),
        h(
          ElButton,
          {
            class: 'el-notification__button',
            type: 'primary',
            onClick: async () => {
              // 点击埋点上报
              dwCollect({
                func: getDwFunc(is_expired, is_trial),
                element: !is_trial && !is_expired ? 'renew_plat' : 'buy_plat',
                action: 'click',
              });

              // 获取支付参数
              const payConfig = await getPayConfig({
                position: getPositionRule({
                  create_time: teamRights.create_time || 0,
                  member_level: teamRights.member_level,
                  position,
                }),
                extra: {
                  purchase_type,
                  team_id,
                  cur_member_id: teamRights.member_id,
                  cur_duration_expires: teamRights.end_time,
                  cur_numeric_value: teamRights.cnt,
                },
              });
              instance.close();
              goPay(payConfig);
            },
          },
          buttonText
        ),
        h(
          ElButton,
          {
            class: 'el-notification__button',
            onClick: () => {
              instance.close();
              window.open(PRIVILEGE_URL);
            },
          },
          '特权详情'
        ),
      ]),
    ]),
  });
};

/**
 * @description: 埋点上报 func 字段
 * @param {boolean} is_expired 是否过期
 * @param {boolean} is_trial 是否试用
 * @return {*}
 */
const getDwFunc = (is_expired: boolean, is_trial: boolean) => {
  if (is_trial) {
    return `try${is_expired ? '' : '_soon'}`;
  } else {
    return `due${is_expired ? '' : '_soon'}`;
  }
};
